

<div >
    <h4 class="m-t-0" mat-dialog-title>{{'deleteConsultantSegmentLabel' | translate}}</h4>
    <p>  "{{deleteName}}" {{'deleteConsultantSegment' | translate}} </p>
    <div mat-dialog-actions align="end">
      <button mat-raised-button color="basic" (click)="closeDialog()">{{'stop' | translate}}</button>
      <button mat-raised-button cdkFocusInitial class="custom-button m-l-10" (click)="deleteConsultantSegment()">{{'deleteCap' | translate}}</button>
    </div>
  </div>